import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import {Alert} from "reactstrap";
import FormHelperText from "@material-ui/core/FormHelperText";
import {DEFAULT_FEEDBACK_INTERNAL_NAME} from "../../constants/FeedbackZoneDefaults";
import FeedbackLocationSelect, {
	loadFeedbackLocations,
	findFeedbackLocationByPkey,
	nextInternalNameForLocation,
	FEEDBACK_FORM_HELPER_TEXT_STYLE,
} from "../Parts/FeedbackLocationSelect";

/**
 *  @property {Regions_Object} state
 *  @property {object} model
 *  @property {Regions_Properties} model.properties
 *  @property {Regions_Is} model.is
 *  @property {Regions_Has} model.has
 */
export default class FeedbackZone extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Regions_Feedback._name);
		this.noDelete = true;
		this.state.feedbackLocations = [];
	}

	async componentDidMount() {
		super.componentDidMount();

		try {
			const feedbackLocations = await loadFeedbackLocations();
			this.setState({feedbackLocations});
		} catch (error) {
		}
	}

	handleFeedbackLocationSelect = (location) => {
		if (!location) {
			this.setState({feedback_location: null});
			return;
		}

		const previousLocation = findFeedbackLocationByPkey(
			this.state.feedbackLocations,
			this.state.feedback_location
		);
		const name = nextInternalNameForLocation(this.state.name, previousLocation, location);

		this.setState({
			feedback_location: location.pkey,
			name,
		});
	}

	async handleSubmit(event, suppressToast = false) {
		const link = (this.state.link || '').trim();
		const prettyName = (this.state.pretty_name || '').trim();
		const ranking = this.state.ranking;
		const rankingMissing = ranking === null || ranking === undefined || `${ranking}`.trim() === '';

		const link_error = link ? '' : 'Required';
		const pretty_name_error = prettyName ? '' : 'Required';
		const ranking_error = rankingMissing ? 'Required' : '';

		if (link_error || pretty_name_error || ranking_error) {
			this.setState({link_error, pretty_name_error, ranking_error});
			return;
		}

		await super.handleSubmit(event, suppressToast);
	}

	form = () => {
		let {properties} = this.model;
		let object = this.state
		let {loading} = this.state

		return (
			<div>
				<Alert color="warning">
					<p style={{fontSize: '18px', marginBottom: '0px'}}>
						Feedback zone ranking is independent of region ranking and only reorders zones within the same region.
					</p>
				</Alert>
				<fieldset>
					<div className="row">
						<div className="col-12">
							<FeedbackLocationSelect
								locations={this.state.feedbackLocations}
								selectedRegionPkey={object.region}
								feedbackLocationPkey={object.feedback_location}
								onChange={this.handleFeedbackLocationSelect}
								disabled={loading}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-6">
							<div className="form-group">
								<Framework.Elements.TextField
									label="Review Link"
									property={properties.link}
									value={object.link}
									error={object.link_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
								<FormHelperText style={FEEDBACK_FORM_HELPER_TEXT_STYLE}>
									Custom g.page review URL. Required. Updating this does not unlink the feedback location.
								</FormHelperText>
							</div>
						</div>
						<div className="col-6">
							<div className="form-group">
								<Framework.Elements.TextField
									label="Internal Name"
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
								<FormHelperText style={FEEDBACK_FORM_HELPER_TEXT_STYLE}>
									Leave blank to use default: {DEFAULT_FEEDBACK_INTERNAL_NAME}
								</FormHelperText>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col-6">
							<div className="form-group">
								<Framework.Elements.TextField
									label="Name to Customer"
									property={properties.pretty_name}
									value={object.pretty_name}
									error={object.pretty_name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
								<FormHelperText style={FEEDBACK_FORM_HELPER_TEXT_STYLE}>
									Required. Shown to the customer in review emails.
								</FormHelperText>
							</div>
						</div>
						<div className="col-6">
							<div className="form-group">
								<Framework.Elements.TextField
									property={properties.ranking}
									value={object.ranking}
									error={object.ranking_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
